import { classes } from '@theme/constants';
import { getAttributeValue } from '@theme/dom';
import { throttle } from '@theme/helpers';
import { HTMLCustomElement } from '@theme/html-custom-element';

class ProductUpsells extends HTMLCustomElement {
  activeIndex = 0;

  connectedCallback() {
    if (super.connectedCallback) super.connectedCallback();

    if (getAttributeValue(this, 'autoplay', true)) {
      this.startAutoplay();
    }

    if (this.refs.paginationButton) {
      this.on('click', this.refs.paginationButton.all, this.handlePaginationEvent.bind(this));
    }

    this.on('open', Array.from(this.querySelectorAll('quick-add toggle-element')), () => {
      this.paused = true;
    });

    this.on('close', Array.from(this.querySelectorAll('quick-add toggle-element')), () => {
      this.paused = false;
    });

    this.on(
      'resize',
      window,
      throttle(
        () => {
          if (this.refs.slide.all[this.activeIndex]) {
            this.goToSlide(this.refs.slide.all[this.activeIndex].dataset.index0);
          }
        },
        100,
        true,
      ),
      null,
      true,
    );
  }

  /**
   * Starts the autoplay timer.
   */
  startAutoplay() {
    clearInterval(this.autoplayInterval);

    this.autoplayInterval = setInterval(
      () => {
        if (!this.paused) {
          this.goToNext();
        }
      },
      getAttributeValue(this, 'autoplay-delay', 5000),
    );
  }

  /**
   * Handles the pagination click event.
   * @param {MouseEvent} event
   */
  handlePaginationEvent(event) {
    this.goToSlide(event.target.dataset.index0);

    if (getAttributeValue(this, 'autoplay', true)) {
      this.startAutoplay();
    }
  }

  /**
   * Navigates to the next slide.
   */
  goToNext() {
    const nextIndex = this.activeIndex === this.refs.slide.all.length - 1 ? 0 : this.activeIndex + 1;
    const nextSlide = this.refs.slide.all[nextIndex];

    if (nextSlide) {
      this.goToSlide(nextSlide.dataset.index0);
    }
  }

  /**
   * Navigates to a specific slide.
   * @param {string} id - The slide identifier.
   */
  goToSlide(id) {
    if (!this.refs.slide) return;

    for (const element of [...this.refs.slide.all, ...this.refs.thumbnail.all]) {
      const isActive = element.dataset.index0 === id;

      element.classList.toggle(classes.active, isActive);

      if (isActive) {
        element.parentElement.style.height = `${element.offsetHeight}px`;

        /**
         * Store the active index for navigation.
         */
        this.activeIndex = parseInt(element.dataset.index0);
      }
    }

    if (this.refs.paginationButton) {
      for (const paginationButton of this.refs.paginationButton.all) {
        paginationButton.classList.toggle(classes.active, paginationButton.dataset.index0 === id);
      }
    }

    Array.from(this.querySelectorAll('quick-add toggle-element')).forEach((element) => element.close());
  }
}

if (!customElements.get('product-upsells')) customElements.define('product-upsells', ProductUpsells);
